import { configureStore } from '@reduxjs/toolkit';

import loginReducer from '../pages/unauthorized/login/loginSlice';

export default configureStore({
  reducer: {
    login: loginReducer,
  },
});
